@use "styles/mixins/_rem.scss" as rem;
@use "styles/mixins/_fonts.scss" as fonts;
@use "styles/mixins/_size.scss" as size;

.footer {
  background-color: var(--color-background-default);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--size-spacing-xl);
  border-top: rem.torem(1px) solid var(--color-border-subtle);

  .footer-list {
    display: flex;
    flex-flow: row wrap;
    gap: var(--size-spacing-m) var(--size-spacing-l);
    justify-content: center;

    @media (min-width: size.$laptop) {
      justify-content: flex-start;
    }
  }

  .footer-list-item {
    white-space: nowrap;
    display: flex;
    align-items: center;
    min-height: rem.torem(20px);
  }

}
